<div class="move-data">
    <div class="join-share-alert" *ngIf="actionMoveOrCopy === WebpathActionType.JOINSHARE">
                  <sync-alert 
                  [type]="alertConfig.type"
                  [showLeadIcon]="true" 
                  [leadIcon]="alertConfig.leadIcon"
                  title=""
                  [description]="alertConfig.description"
                  [showActions]="false"
                  [showPrimaryAction]="false"
                  [showSecondaryAction]="false"
                  [showCloseButton]="false">
                  </sync-alert>
    </div>
    <div class="header-section">
        <sync-tabs *ngIf="breadCrumbItems?.items && breadCrumbItems.items.length < 1" [tabLinks]="tabLinks"
            tabsPosition="center" [onSelectionTab]="onTabChange">
        </sync-tabs>
    </div>
    <div class="header-section header-section-breadcrumb" *ngIf="(pickerView?.parentList && pickerView?.parentList?.length > 1)">
        <sync-breadcrumb [items]="breadCrumbItems?.items" (onMenuItemClick)="handleMenuItemClick($event)"
            (onBack)="handleBackClick($event)" (onItemClicked)="handleMenuItemClick($event)"
            [showBackButton]="isSmallScreen ? true : false" [level]="'body-1'" [lastLevel]="'body-bold-1'"
            [menuListLimit]="pickerView.parentList?.length">
        </sync-breadcrumb>
    </div>
    <sync-divider *ngIf="(pickerView?.parentList && pickerView?.parentList?.length > 1)"></sync-divider>
    <div *ngIf="isLoading">
        <sync-spinner></sync-spinner>
    </div>

    <div *ngIf="!isLoading" class="full-folder-list" [ngClass]="{ 'join-share-list' : actionMoveOrCopy === WebpathActionType.JOINSHARE }">
        <p class="sub-content caption" *ngIf="isSelectedItemsInCurrentDir">
            Your selected item(s) are already in this directory
        </p>
            <div class="directory-list" syncInfiniteScrollable [activateScroll]="true" (scrolled)="handleScroll($event)" [scrollOffsetPercent]="5"
            [isLoading]="!!(activateScroll && dirList.length)">
                <sync-list [ListItems]="itemListForLazyLoadData" selectionType="row" [isSelectable]="true" [isMultiselect]="false" />
                <div *ngIf="activateScroll && dirList.length">
                    <sync-spinner></sync-spinner>
                </div>
            </div>
        <div class="no-data subtitle-1" *ngIf="!dirList.length">
            <div>You've reached the last folder.</div>
            <div>{{actionMoveOrCopy}} your items here or create a new folder!</div>
        </div>
    </div>
</div>